<template>
    <div
        class="widget d-flex flex-column justify-content-start align-items-start px-1 px-md-3 py-1 py-md-2 m-1"
    >
        <h6 class="mb-0 text-uppercase">Goal progress</h6>
        <small class="text-muted mb-0"
            ><em>current length: {{ moment(goal.created_at).fromNow(true) }}</em></small
        >
        <hr style="width:100%;margin:0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;" />
        <div class="mb-2 w-100">
            <p class="mb-0 text-muted">{{ targets.length }} Current Targets</p>
            <p class="mb-0 text-muted">{{ goal.parameters.goal }} Planned Targets</p>
            <p class="mb-0 text-muted">{{ targets.filter(t => t.mastered).length }} Mastered</p>
            <p class="mb-0 text-muted">{{ avgDuration }} Days Average Mastery</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoalsProgressProbe",
    props: ["goal", "targets"],
    data() {
        return {};
    },
    computed: {
        avgDuration() {
            let mastered = this.targets.filter(t => t.mastered);
            let durations = [];
            mastered.forEach(m => {
                let start = this.moment(m.introduced);
                let mastered = this.moment(m.updated);
                durations.push(start.diff(mastered, "days"));
            });
            return durations.length ? durations.reduce((a, b) => a + b) : 0;
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
</style>
